export const TAGS_HAS_ERRED = 'TAGS_HAS_ERRED';
export const TAGS_IS_LOADING = 'TAGS_IS_LOADING';
export const TAGS_FETCHED_OK = 'TAGS_FETCHED_OK';
export const TAGS_SET_ACTIVE = 'TAGS_SET_ACTIVE';



// WEBPACK FOOTER //
// ./src/data/constants/tags.js